module.exports = __webpack_public_path__ + "media/images/default/shared/header/nav-cover7-fa30eaa2d24246380657674e18fb3407.jpg";